import { SparklineCell, TextCell } from "@similarweb/pro-logic-components";
import { colorsPalettes, rgba } from "@similarweb/styles";

import { NOT_AVAILABLE } from "app/filters/const";
import type { TrendItem } from "app/pages/sales-intelligence/common-components/table-cells";
import { ZonedSparklineCell } from "app/pages/sales-intelligence/common-components/table-cells/components/ZonedSparklineCell";
import { trendItemsToSparklineData } from "app/pages/sales-intelligence/common-components/table-cells/utils/cellValue";

import { useTractionTrendPeriod } from "../../../hooks/cells/useTractionTrendPeriod";

const SPARKLINE_HEIGHT = 30;

const ZONE_OPACITY = 0.15;
const ZONE_COLOR_UP = rgba(colorsPalettes.green.s100, ZONE_OPACITY);
const ZONE_COLOR_DOWN = rgba(colorsPalettes.red.s100, ZONE_OPACITY);

type Props = {
    value?: readonly TrendItem[];
};

export const SignalTrafficTractionCellContainer = ({ value = [] }: Props) => {
    const { trendDirection, periodValue } = useTractionTrendPeriod();

    const data = trendItemsToSparklineData(value);

    if (data.length === 0) {
        return <TextCell>{NOT_AVAILABLE}</TextCell>;
    }

    if (!trendDirection || !periodValue) {
        return (
            <SparklineCell
                type="area"
                data={data as number[]}
                height={SPARKLINE_HEIGHT}
                min={0}
            />
        );
    }

    const zoneStartIndex = Math.max(0, data.length - periodValue - 1);
    const zoneColor = trendDirection === "up" ? ZONE_COLOR_UP : ZONE_COLOR_DOWN;

    return (
        <ZonedSparklineCell
            data={data}
            height={SPARKLINE_HEIGHT}
            zoneStartIndex={zoneStartIndex}
            zoneColor={zoneColor}
            min={0}
        />
    );
};
